/**
 * Экшены просмотрщика для отправки метрик.
 */
export enum EViewerActions {
    SHOW_EDIT = 'show-edit',
    CLICK_EDIT = 'click-edit',
}
